import { TokenMetadata } from '../../../services/ft-contract';
import {
  SwapContractType,
  SwapMarket,
  ExchangeEstimate,
} from '../../../pages/SwapPage';
import { DisplayIcon } from '../../tokens/Icon';
import { toRealSymbol } from '../../../utils/token';
import { getDexIcon, CONTRACT_LABELS, configV2 } from './routeHelpers';
import { HiOutlineExternalLink } from '../../reactIcons/index';
import React, { useEffect, useMemo, useState } from 'react';
import {
  IEstimateSwapServerView,
  getTokensOfRoute,
} from '../../../services/smartRouterFromServer';
import {
  separateRoutes,
  getPoolAllocationPercents,
  getRouteAllocationPercents,
} from '../../../utils/numbers';
import { PolygonArrow, LeftBracket, RightBracket } from './routeIcons';
import { isMobile } from '../../../utils/device';
import { getV3PoolId } from '../../../services/swapV3';
import Modal from 'react-modal';
import { ModalWrapper } from '../ModalWrapper';
import { FormattedMessage } from 'react-intl';
import { get_pool_name } from '../../../services/dcl/dclNaming';
import { openUrl } from '../../../utils/navigation';

const TradeRouteHub = ({
  token,
  contract,
  poolId,
}: {
  token: TokenMetadata;
  contract: SwapContractType;
  poolId?: string | number;
}) => {
  const contractToMarket = (): SwapMarket => {
    if (contract.toLowerCase().includes('ref')) return 'ref';
    if (contract.toLowerCase().includes('trisolaris')) return 'tri';
  };
  return (
    <div
      className="flex flex-col justify-center  relative z-10 text-primaryText text-xs rounded-md px-2.5 py-1 border border-swapCardBorder bg-swapCardGradient"
      style={{
        height: '60px',
      }}
    >
      <div className="border-b pb-1 frcs border-primaryText border-opacity-30">
        <DisplayIcon token={token} height="14px" width="14px" />
        <span className="block ml-1 text-white text-xs w-28 truncate">
          {toRealSymbol(token.symbol)}
        </span>
      </div>

      <div className="w-full frcs pt-1 relative top-0.5 rounded-md">
        <div
          style={{
            height: '13px',
            width: '13px',
          }}
          className="frcc"
        >
          {getDexIcon(contractToMarket())}
        </div>

        <span className="ml-1 mr-1">
          {CONTRACT_LABELS[contract] || contract}
        </span>
        <span
          className={`cursor-pointer block mr-1.5 ${
            configV2.BLACK_LIST_DCL_POOL_IDS_IN_POOLS.includes(
              poolId?.toString()
            )
              ? 'hidden'
              : ''
          }`}
          onClick={() => {
            if (
              typeof poolId === 'undefined' ||
              poolId === null ||
              poolId === 0
            )
              return;
            if (contract === 'Ref_CLMM') {
              openUrl(`/pools/manage/v4/${poolId}`);
              return;
            }

            openUrl(
              typeof poolId === 'number'
                ? `/pool/${poolId}`
                : `/poolV2/${get_pool_name(poolId)}`
            );
          }}
        >
          {!(
            typeof poolId === 'undefined' ||
            poolId === null ||
            poolId === 0
          ) && (
            <HiOutlineExternalLink className="hover:text-white"></HiOutlineExternalLink>
          )}
        </span>

        <span>100%</span>
      </div>
    </div>
  );
};

export const TradeRoute = ({
  trade,
  tokenIn,
  tokenOut,
}: {
  trade: ExchangeEstimate;
  tokenIn: TokenMetadata;
  tokenOut: TokenMetadata;
}) => {
  const [estimatesServerUI, setEstimatesServerUI] =
    useState<IEstimateSwapServerView>();
  const { estimates, estimatesServer } = trade || {};
  const identicalRoutes = estimates
    ? separateRoutes(estimates, estimates[estimates.length - 1].outputToken)
    : [];

  const pools = identicalRoutes.map((route) => route[0]).map((hub) => hub.pool);
  useEffect(() => {
    if (estimatesServer) {
      getTokensDataOfEstimatesServer();
    } else {
      setEstimatesServerUI(undefined);
    }
  }, [JSON.stringify(estimatesServer || {})]);
  async function getTokensDataOfEstimatesServer() {
    const pending = estimatesServer.routes.map((route) =>
      getTokensOfRoute(route)
    );
    const tokens_of_routes = await Promise.all(pending);
    estimatesServer.routes.map((route, index) => {
      route.tokens = tokens_of_routes[index];
    });
    setEstimatesServerUI(estimatesServer);
  }
  const percents = useMemo(() => {
    try {
      return getPoolAllocationPercents(pools);
    } catch (error) {
      if (identicalRoutes.length === 0) return ['100'];
      else return identicalRoutes.map((route) => route[0].percent);
    }
  }, [identicalRoutes, pools]);
  const percentsServer = useMemo(() => {
    const routes = estimatesServer?.routes || [];
    try {
      return getRouteAllocationPercents(routes);
    } catch (error) {
      return ['100'];
    }
  }, [(estimatesServer?.routes || []).length]);
  if (!tokenIn || !tokenOut) return null;

  if (!trade || !trade?.availableRoute || tokenIn?.id === tokenOut?.id) {
    return (
      <div className="frcb relative">
        <DisplayIcon token={tokenIn} height="26px" width="26px" />
        <div className="w-full frcc mx-2 relative">
          <div
            className="border border-dashed absolute left-5 opacity-30 border-primaryText w-full px-3"
            style={{
              width: 'calc(100% - 32px)',
            }}
          ></div>

          <div
            className="relative z-50 text-primaryText text-opacity-30"
            style={{
              background: '#001220',
            }}
          >
            {'/  /'}
          </div>
        </div>
        <div className="absolute right-8">
          <PolygonArrow color="#303E48" />
        </div>

        <DisplayIcon token={tokenOut} height="26px" width="26px" />
      </div>
    );
  }
  const routeLength =
    identicalRoutes.length || trade.estimatesServer?.routes?.length;
  return (
    <div className="frcb">
      <DisplayIcon token={tokenIn} height="26px" width="26px" />
      <LeftBracket size={routeLength} />
      {/* from script routes */}
      {trade.estimates ? (
        <div className={`w-full  mx-2 xsm:overflow-x-auto hideScroll relative`}>
          {identicalRoutes.map((route, routeIndex) => {
            return (
              <div
                key={routeIndex}
                className="relative frcb my-3 "
                style={{
                  width: isMobile() ? '460px' : '',
                }}
              >
                <span className="text-xs text-senderHot">
                  {percents[routeIndex]}%
                </span>
                <div
                  className="border border-dashed absolute left-5 opacity-30 border-primaryText w-full px-3"
                  style={{
                    width: 'calc(100% - 32px)',
                  }}
                ></div>
                <div className="frcs">
                  {route[0].tokens
                    .slice(1, route[0].tokens.length)
                    .map((token, index) => {
                      return (
                        <>
                          <TradeRouteHub
                            poolId={
                              route[index].contract === 'Ref_DCL'
                                ? getV3PoolId(
                                    tokenIn.id,
                                    tokenOut.id,
                                    trade.fee * 100
                                  )
                                : route[index].contract === 'Ref_Classic'
                                ? Number(route[index].pool.id)
                                : route[index].contract === 'Ref_CLMM'
                                ? (
                                    route[index] as {
                                      clmm?: { pool?: { pool_id?: string } };
                                    }
                                  ).clmm?.pool?.pool_id
                                : null
                            }
                            token={token}
                            contract={route[index].contract}
                          />
                          {token.id !==
                            route[0].tokens[route[0].tokens.length - 1]?.id && (
                            <div className="mx-3">
                              <PolygonArrow />
                            </div>
                          )}
                        </>
                      );
                    })}
                </div>

                <PolygonArrow />
              </div>
            );
          })}
        </div>
      ) : null}

      {/* from server routes */}
      {estimatesServerUI ? (
        <div className={`w-full  mx-2 xsm:overflow-x-auto hideScroll relative`}>
          {estimatesServerUI.routes.map((route, routeIndex) => {
            const { pools, tokens } = route;
            return (
              <div
                key={routeIndex}
                className="relative frcb my-3 "
                style={{
                  width: isMobile() ? '620px' : '',
                }}
              >
                <span className="text-xs text-senderHot">
                  {percentsServer[routeIndex]}%
                </span>
                <div
                  className="border border-dashed absolute left-5 opacity-30 border-primaryText w-full px-3"
                  style={{
                    width: 'calc(100% - 32px)',
                  }}
                ></div>
                <div className="frcs">
                  {tokens?.slice(1, tokens.length).map((token, index) => {
                    return (
                      <>
                        <TradeRouteHub
                          poolId={Number(pools[index].pool_id)}
                          token={token}
                          contract="Ref_Classic"
                        />
                        {token.id !== tokens[tokens.length - 1]?.id && (
                          <div className="mx-3">
                            <PolygonArrow />
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>

                <PolygonArrow />
              </div>
            );
          })}
        </div>
      ) : null}

      <RightBracket size={routeLength} />

      <DisplayIcon token={tokenOut} height="26px" width="26px" />
    </div>
  );
};

export const TradeRouteModal = (
  props: Modal.Props & {
    trade: ExchangeEstimate;
  }
) => {
  return (
    <ModalWrapper
      title={
        <FormattedMessage
          id="your_trade_route_capital"
          defaultMessage={`Your Trade Route`}
        />
      }
      {...props}
      customWidth={isMobile() ? '95vw' : '800px'}
    >
      <div className="w-full mt-7">
        <TradeRoute
          trade={props.trade}
          tokenIn={props.trade.tokenIn}
          tokenOut={props.trade.tokenOut}
        />
      </div>
    </ModalWrapper>
  );
};
